





import Vue from 'vue'
import { mapGetters } from 'vuex'
import BroadcastForm from '@/components/BroadcastForm.vue'
import BroadcastPhonePreview from '@/components/BroadcastPhonePreview.vue'
export default Vue.extend({
    components: { BroadcastForm, BroadcastPhonePreview },
    props: ['id'],
    data: () => ({
        formClick: null,
        //  Determines if we have finished mounting the component or not
        mounted: false,
        toolbar: {
            title: 'Broadcasts',
            left: [
                {
                    title: 'Back',
                    icon: 'mdi-chevron-left',
                    back: '/broadcasts',
                    tooltip: 'Back',
                    permission: 0,
                    feature: null
                }
            ],
            right: []
        },
        navigateAwayPath: null
    }),
    async mounted() {
        //  Check if a broadcast is set in the url params
        const id = this.id

        //  If a broadcast id is set, load it
        if (id) this.getDraftData()

        //  We finished doing everything we needed to so we are now mounted
        this.mounted = true
    },
    beforeRouteLeave(to, from, next) {
        //  Unset our hint
        this.$store.commit('broadcastsViewMediaHintSet', false)

        //  Unset our contact count
        this.$store.commit('broadcastsViewSelectedBroadcastTotalCountSet', 0)

        //  Check if our broadcast edited
        const edited = this.$refs.broadcastForm?.broadcastEdited

        //  Check if our broadcast has schedules
        const schedule = this.$refs.broadcastForm.broadcast.schedule

        //  If our broadcast has NOT been edited, just continue
        //  If creating a group or user came from form click, let user proceed to next route
        //  If we were editing a scheduled broadcast, just continue
        if (this.formClick || !edited || schedule) return next()
        //  Else if navigatepath not set
        else if (!this.navigateAwayPath) {
            //  Set path
            this.navigateAwayPath = to.path

            //  Get our broadcast form ref
            const ref = this.$refs.broadcastForm

            //  If the ref doesn't exist, do nothing
            if (!ref) return

            //  Pop save draft pop up
            return ref.popSaveDraft(to.path)
        }
        next()
    },
    beforeDestroy() {
        //  When leaving, we want to get rid of our selected broadcast
        this.$store.commit('broadcastsViewSelectedBroadcastSet', null)
    },
    computed: {
        ...mapGetters({
            broadcast: 'broadcastsViewSelectedBroadcast',
            paginating: 'broadcastsViewPaginating'
        })
    },
    methods: {
        async getDraftData(): Promise<void> {
            //  Wrap both awaits in a promise to increase performance
            const [draftGet, draftData] = await Promise.all([
                this.$store.dispatch('broadcastsViewSelectedBroadcastGet', this.id),
                this.$store.dispatch('draftGet', this.id)
            ])

            //  Get our total number of contacts
            this.$store.dispatch(
                'broadcastsViewSelectedBroadcastTotalCount',
                this.broadcast
            )

            //  Set the data to the broadcast object
            this.broadcast.groups = draftData.groups
            this.broadcast.persons = draftData.persons
            this.broadcast.exclude_persons = draftData.excludePersons
            this.broadcast.exclude_groups = draftData.excludeGroups

            //  If group query exists
            if (this.$route.query.group) {
                //  Store group id
                const groupId = this.$route.query.group

                // Get group object
                const group = await this.$store.dispatch('groupsFind', groupId)

                // Attach group to broadcast
                this.broadcast.group_ids.push(groupId)
                if (this.broadcast.groups) this.broadcast.groups.push(group)
                else this.broadcast.groups = [group]
            }

            //  Call method in the child component to clone broadcast
            this.$refs.broadcastForm.cloneBroadcast()
        },
        //  Method to handle emit event coming from broadcast form
        routeNext(): void {
            //  If path present, route to it
            if (this.navigateAwayPath) this.$router.push(this.navigateAwayPath)
        }
    },
    watch: {
        id(val: number): void {
            //  Set our broadcast to this id
            this.$store.dispatch('broadcastsViewSelectedBroadcastGet', val)
        },
        broadcast(): void {
            //  If our broadcast is NOT null then get draft data
            if (this.broadcst) this.getDraftData()
        }
    }
})
